import { render, staticRenderFns } from "./coupon-manage.vue?vue&type=template&id=52c127d5&scoped=true&"
import script from "./coupon-manage.vue?vue&type=script&lang=js&"
export * from "./coupon-manage.vue?vue&type=script&lang=js&"
import style0 from "./coupon-manage.vue?vue&type=style&index=0&id=52c127d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c127d5",
  null
  
)

export default component.exports